import {DateString, DateStringNullable, Dictionary, NullableKeys} from '@fl/cmsch-fe-library';

import {RoleApproval} from 'api/gen/RoleApproval';

/** Form name used for association and other-subject membership edits. */
export const subjectFormName = 'SubjectForm';

/** Values submitted by the subject relation form. */
export interface SubjectFormValues {
    /** Approval start date. */
    approvedFrom: DateStringNullable;
    /** Approval end date. */
    approvedTo: DateStringNullable;
    /** Selected subject id. */
    subjectId: number;
    /** Selected role ids. */
    roleIds: Array<number>;
    /** Owning user profile id. */
    userProfileId: number;
    /** Role ids that belong to the current user profile. */
    userProfileAssociationRoleIds: Array<number>;
}

/** Empty form values used before the subject form is initialized. */
export const subjectFormInitialValues: NullableKeys<SubjectFormValues> = {
    approvedFrom: null,
    approvedTo: null,
    subjectId: null,
    roleIds: [],
    userProfileId: null,
    userProfileAssociationRoleIds: [],
};

/** Initial data extracted from an existing subject relation row. */
export interface SubjectFormEntryData {
    /** Existing role id when the row is edited in place. */
    roleId: number | null;
    /** Selected subject id. */
    subjectId: number;
    /** Existing user-profile subject role id when editing. */
    userProfileSubjectRoleId: number | null;
    /** Approval start date. */
    approvedFrom: DateString;
    /** Approval end date. */
    approvedTo: DateStringNullable;
    /** Available role approvals for the selected subject. */
    roles: Array<RoleApproval>;
}

/** Validation error map for the subject relation form. */
export type SubjectFormValuesErrors = Dictionary<keyof SubjectFormValues, string>;

/** Distinguishes association relations from other-subject relations. */
export type SubjectFormType = 'ASSOCIATION' | 'OTHER_SUBJECT';
